module.exports = "/images/hu.svg";